import ContactCard from './styled';

export default ContactCard;
